module.exports = __webpack_public_path__ + "static/media/123.b70be6b.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/123.mp4
// module id = H247
// module chunks = 1